import { RefreshCw } from 'lucide-react';
import { ApiError } from '@/lib/apiClient';
import { Alert, Button } from '@/components/ui/primitives';
import { CopyButton } from '@/components/common/indicators';

/** Rendu d'erreur uniforme : message, code, piste de résolution, diagnostic copiable. */
export function ErrorState({
  error,
  onRetry,
  title = 'Une erreur est survenue',
}: {
  error: unknown;
  onRetry?: () => void;
  title?: string;
}): JSX.Element {
  const apiError = error instanceof ApiError ? error : null;
  const message = apiError?.message ?? (error instanceof Error ? error.message : String(error));

  const diagnostic = JSON.stringify(
    {
      code: apiError?.code ?? 'CLIENT_ERROR',
      status: apiError?.status ?? null,
      endpoint: apiError?.endpoint ?? null,
      requestId: apiError?.requestId ?? null,
      message,
      hint: apiError?.hint ?? null,
      details: apiError?.details ?? null,
      at: new Date().toISOString(),
    },
    null,
    2,
  );

  return (
    <Alert
      tone="danger"
      title={title}
      actions={
        <>
          {onRetry ? (
            <Button size="sm" variant="outline" icon={<RefreshCw className="h-3.5 w-3.5" />} onClick={onRetry}>
              Réessayer
            </Button>
          ) : null}
          <CopyButton value={diagnostic} label="Copier le diagnostic" />
        </>
      }
    >
      <p className="text-sm text-foreground">{message}</p>
      <div className="mt-1 space-y-0.5">
        {apiError ? (
          <p>
            Code : <code className="font-mono">{apiError.code}</code>
            {apiError.status ? ` · HTTP ${apiError.status}` : ''}
            {apiError.endpoint ? ` · ${apiError.endpoint}` : ''}
            {apiError.requestId ? ` · requête ${apiError.requestId}` : ''}
          </p>
        ) : null}
        {apiError?.hint ? <p>Piste : {apiError.hint}</p> : null}
      </div>
    </Alert>
  );
}
